import { Summary, WorkOrderDetailType } from '@atom/types/work';
import { numberToLocaleString } from '@atom/utilities/currencyUtility';
import textDisplayUtilities from '@atom/utilities/textDisplayUtilities';
import timeUtilities from '@atom/utilities/timeUtilities';

import DetailRow from '../shared/DetailRow';
import SectionHeading from '../shared/SectionHeading';

import sidebarClasses from '../shared/sidebars.module.css';
import classes from './workOrder.module.css';

export type WorkInfoTabProps = { work: WorkOrderDetailType };

const WorkInfoTab = ({ work }: WorkInfoTabProps) => {
  const point = work.location?.type === 'Point' ? work.location : undefined;
  const lat = point ? textDisplayUtilities.latLong(point.coordinates[1]) : '-';
  const lng = point ? textDisplayUtilities.latLong(point.coordinates[0]) : '-';

  return (
    <div className={sidebarClasses.infoPanel}>
      <SectionHeading title="Details" />
      <div className={sidebarClasses.infoDetailSection}>
        <DetailRow label="Asset Name" value={work.inventoryAssetName} />
        <DetailRow label="Lat & Long" value={`${lat}, ${lng}`} />
        <DetailRow
          label="Due Date"
          value={timeUtilities.setDisplayDate(work.dueDate)}
        />
        <DetailRow
          label="Completed Date"
          value={timeUtilities.setDisplayDate(work.completionDate)}
        />
        <DetailRow
          label="Estimated Cost"
          value={numberToLocaleString(work.estimatedCost)}
        />
      </div>
      <SectionHeading title="Summary" />
      <div className={classes.summarySections}>
        {(work.summary ?? []).map((section: Summary, index: number) => (
          <div key={index}>
            <div className={classes.summarySectionTitle}>{section.title}</div>
            <div className={classes.summarySectionBody}>{section.contents}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkInfoTab;
